export const state = function () {
  return {
    available_sortings: [
      {
        display_value: "band.sendtrack.cardDisplay02",
        method_key: "sortByScore",
      },
      {
        display_value: "band.sendtrack.cardDisplay03",
        method_key: "sortByDate",
      },
      {
        display_value: "band.sendtrack.cardDisplay04",
        method_key: "sortByFeedback",
      },
    ],
    selected_sort_index: 0,
    display_range: 12,
  }
}

export const mutations = {
  SELECT_SORT_INDEX: function (state, index) {
    state.selected_sort_index = index
  },
  SET_DISPLAY_RANGE: function (state, range) {
    state.display_range = range
  },
}
